const url = 'https://www.bradfordwhiterightspec.com/CrossReferenceAPI/api'

export default {    
    inputCountries: url + '/input/countries',
    inputManufacturers: url + '/input/manufacturers',
    inputModels: url + '/input/models',    
    solution: url + '/solution',

}
